import styled from 'styled-components';

export const NotesFormContainer = styled.div`
  .custom-form-layout {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-end;

    .field {
      flex: 2 1 300px;
      min-width: 200px;

      @media (max-width: 768px) {
        flex: 1 1 100%;
        min-width: 100%;
      }
    }

    .tag-button-container {
      display: flex;
      gap: 8px;
      align-items: flex-end;
      flex: 1 1 200px;
      min-width: 200px;

      .field {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        margin: 0 !important;
        width: auto !important;

        .ui.selection.dropdown {
          width: 100% !important;
          min-width: 0 !important;
        }
      }

      .ui.button {
        flex: 0 0 auto !important;
        min-width: auto !important;
        margin: 0 !important;
        height: auto !important;
        width: auto !important;
        max-width: 50px !important;
      }

      @media (max-width: 768px) {
        flex: 1 1 100%;
        min-width: 100%;

        .field {
          flex: 1 1 auto !important;
          min-width: 0 !important;
          width: auto !important;
        }

        .ui.button {
          flex: 0 0 auto !important;
        }
      }
    }
  }
`;

export const CommentGroup = styled.div`
  margin-bottom: 20px;

  .ui.comments {
    max-width: 100%;
  }
`;

export const FoodRecommendationButton = styled.div`
  margin-top: 16px;

  .ui.button {
    margin-top: 8px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 20px 0;

  @media (max-width: 768px) {
    margin: 16px 0;
  }
`;
